var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivateLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 51,
    viewBox: "0 0 60.854 13.494",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132795622234735362310000011989901471959048354_",
    x1: 130.73,
    x2: 162.77,
    y1: 62.927,
    y2: 101.11,
    gradientTransform: "translate(0,-10)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC772E",
    offset: 0.00066138
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27336",
    offset: 0.0311
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7566D",
    offset: 0.2684
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B3F99",
    offset: 0.4804
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402FB9",
    offset: 0.6596
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2625CD",
    offset: 0.7991
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C21D4",
    offset: 0.8817
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient51245",
    x1: 130.73,
    x2: 162.77,
    y1: 62.927,
    y2: 101.11,
    gradientTransform: "translate(0,-10)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#SVGID_00000132795622234735362310000011989901471959048354_"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26412 0 0 .26412 -32.376 -11.744)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m197.19 82.88c-1.92 0-3.66-0.48-5.22-1.43s-2.8-2.26-3.71-3.93c-0.91-1.66-1.37-3.56-1.37-5.7 0-2.1 0.44-3.97 1.33-5.63s2.11-2.97 3.66-3.94c1.56-0.97 3.33-1.45 5.32-1.45 1.62 0 3.12 0.34 4.48 1.01 1.37 0.68 2.45 1.62 3.25 2.82v-3.19h5.05v20.78h-5.05v-3.32c-0.92 1.26-2.04 2.24-3.37 2.93-1.33 0.7-2.79 1.05-4.37 1.05zm1.44-4.32c1.26 0 2.37-0.29 3.34-0.86s1.72-1.37 2.27-2.37c0.55-1.01 0.82-2.17 0.82-3.48 0-1.3-0.28-2.46-0.83-3.47s-1.31-1.81-2.27-2.38-2.07-0.86-3.33-0.86c-1.24 0-2.35 0.29-3.33 0.86-0.97 0.58-1.74 1.37-2.29 2.38s-0.83 2.17-0.83 3.47c0 1.29 0.28 2.44 0.83 3.46s1.32 1.82 2.28 2.39c0.97 0.57 2.08 0.86 3.34 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m226.51 82.88c-1.58 0-3.07-0.28-4.45-0.84-1.39-0.56-2.61-1.34-3.66-2.34-1.06-1-1.88-2.17-2.49-3.51-0.6-1.34-0.9-2.79-0.9-4.34 0-1.5 0.29-2.92 0.86-4.25s1.38-2.51 2.41-3.52 2.25-1.81 3.65-2.39 2.91-0.87 4.54-0.87c1.35 0 2.65 0.2 3.89 0.59s2.26 0.91 3.07 1.54l-1.81 3.41c-1.19-0.91-2.66-1.36-4.42-1.36-1.42 0-2.65 0.32-3.69 0.95-1.04 0.64-1.84 1.48-2.4 2.53s-0.84 2.17-0.84 3.38c0 1.29 0.3 2.45 0.89 3.49 0.6 1.04 1.42 1.86 2.47 2.47 1.05 0.6 2.26 0.9 3.62 0.9 0.87 0 1.67-0.12 2.42-0.37 0.75-0.24 1.4-0.57 1.94-0.99l1.83 3.41c-0.83 0.62-1.85 1.13-3.06 1.53-1.23 0.38-2.52 0.58-3.87 0.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m244.16 82.88c-1.87 0-3.32-0.61-4.36-1.83s-1.56-2.93-1.56-5.13v-10.63h-2.56v-3.83h2.56v-7.77h5.05v7.77h4.77v3.83h-4.77v10.29c0 0.91 0.18 1.6 0.54 2.09s0.87 0.73 1.53 0.73c0.72 0 1.37-0.23 1.97-0.69l1.26 4.06c-0.61 0.34-1.31 0.61-2.09 0.81-0.79 0.2-1.57 0.3-2.34 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m255.87 57.19c-0.57 0-1.08-0.14-1.54-0.42s-0.83-0.65-1.11-1.12-0.42-0.98-0.42-1.55 0.14-1.08 0.42-1.53 0.65-0.82 1.11-1.1 0.97-0.42 1.54-0.42 1.08 0.14 1.53 0.42 0.82 0.64 1.1 1.1c0.28 0.45 0.42 0.96 0.42 1.53s-0.14 1.09-0.42 1.55c-0.28 0.47-0.64 0.84-1.1 1.12-0.45 0.29-0.96 0.42-1.53 0.42zm-2.54 25.04v-20.77h5.05v20.78h-5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m271.98 82.23-10.63-20.78h5.97l6.35 13.98 6.35-13.98h5.97l-10.63 20.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m297.63 82.88c-1.92 0-3.66-0.48-5.22-1.43s-2.8-2.26-3.71-3.93c-0.91-1.66-1.37-3.56-1.37-5.7 0-2.1 0.44-3.97 1.33-5.63s2.11-2.97 3.66-3.94c1.56-0.97 3.33-1.45 5.32-1.45 1.62 0 3.12 0.34 4.48 1.01 1.37 0.68 2.45 1.62 3.25 2.82v-3.19h5.05v20.78h-5.05v-3.32c-0.92 1.26-2.04 2.24-3.37 2.93-1.34 0.7-2.79 1.05-4.37 1.05zm1.44-4.32c1.26 0 2.37-0.29 3.34-0.86s1.72-1.37 2.27-2.37c0.55-1.01 0.82-2.17 0.82-3.48 0-1.3-0.28-2.46-0.83-3.47s-1.31-1.81-2.27-2.38-2.07-0.86-3.33-0.86c-1.24 0-2.35 0.29-3.33 0.86-0.97 0.58-1.74 1.37-2.29 2.38s-0.83 2.17-0.83 3.47c0 1.29 0.28 2.44 0.83 3.46s1.32 1.82 2.28 2.39c0.97 0.57 2.08 0.86 3.34 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m323.38 82.88c-1.87 0-3.32-0.61-4.36-1.83s-1.56-2.93-1.56-5.13v-10.63h-2.56v-3.83h2.56v-7.77h5.05v7.77h4.77v3.83h-4.77v10.29c0 0.91 0.18 1.6 0.54 2.09s0.87 0.73 1.53 0.73c0.72 0 1.37-0.23 1.97-0.69l1.26 4.06c-0.61 0.34-1.31 0.61-2.09 0.81-0.79 0.2-1.57 0.3-2.34 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m342.47 82.88c-2.22 0-4.21-0.48-5.97-1.44s-3.14-2.27-4.16-3.94c-1.01-1.66-1.52-3.54-1.52-5.62 0-1.56 0.29-3 0.86-4.33s1.38-2.51 2.41-3.52 2.24-1.81 3.6-2.37c1.37-0.57 2.84-0.85 4.42-0.85 2.16 0 4.06 0.45 5.69 1.34s2.9 2.14 3.81 3.74 1.37 3.45 1.37 5.55c-0.01 0.18-0.02 0.33-0.03 0.46s-0.03 0.32-0.07 0.58h-16.92c0 1.24 0.28 2.35 0.85 3.31s1.36 1.71 2.38 2.24 2.19 0.8 3.52 0.8c1.26 0 2.38-0.25 3.36-0.76s1.87-1.28 2.67-2.32l3.67 1.89c-0.99 1.65-2.36 2.94-4.11 3.87-1.73 0.91-3.68 1.37-5.83 1.37zm-6.27-13.57h11.79c-0.18-0.95-0.53-1.77-1.08-2.46-0.54-0.69-1.22-1.23-2.05-1.61-0.83-0.39-1.74-0.58-2.76-0.58-1.07 0-2.02 0.19-2.86 0.56s-1.52 0.91-2.04 1.6c-0.52 0.7-0.85 1.53-1 2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m136.88 74.64-14.3-8.25v16.69c0 1.39 0.74 2.68 1.95 3.38l14.42 8.33v-16.56c0-1.48-0.79-2.85-2.07-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m168.23 56.72-19.9-11.49c-1.21-0.7-2.69-0.7-3.9 0l-14.52 8.38 21.68 12.51c1.28 0.74 2.08 2.11 2.08 3.59v25.14l14.56-8.41c1.21-0.7 1.95-1.98 1.95-3.38v-22.97c0-1.39-0.74-2.68-1.95-3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m143.57 70.45-17.97-10.43v5.64l12.87 7.43c1.74 1 2.82 2.87 2.82 4.88v14.55l4.89 2.79v-20.44c0-1.82-0.99-3.51-2.61-4.42z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient51245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.88 74.64-14.3-8.25v16.69c0 1.39 0.74 2.68 1.95 3.38l14.42 8.33v-16.56c0-1.48-0.79-2.85-2.07-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.23 56.72-19.9-11.49c-1.21-0.7-2.69-0.7-3.9 0l-14.52 8.38 21.68 12.51c1.28 0.74 2.08 2.11 2.08 3.59v25.14l14.56-8.41c1.21-0.7 1.95-1.98 1.95-3.38v-22.97c0-1.39-0.74-2.68-1.95-3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.57 70.45-17.97-10.43v5.64l12.87 7.43c1.74 1 2.82 2.87 2.82 4.88v14.55l4.89 2.79v-20.44c0-1.82-0.99-3.51-2.61-4.42z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateLogo);
export default __webpack_public_path__ + "static/media/activate-logo.ee2b0b4ce90a40055b7ed875f9c18d25.svg";
export { ForwardRef as ReactComponent };